@if(impl?.fileForPreview?.previewFromUpload && impl?.fileForPreview?.operationsWrapper != universalService.currentFileOpsWrapper){
  <main-upload-preview-file-operations/>
}
<app-lottie-animations-and-no-internet/>

<div class="modal fade" id="preview-modal" (swipe)="onSwipe($event)" [ngStyle]="{'display': universalService.showPreview ? 'block' : 'none', 'opacity': 1}" tabindex="-1" role="dialog">
  <div class="modal-header" [ngStyle]="universalService.activeRepo == 'share' && { 'padding':  '10px'}">
    @if (!universalService.isMobileDevice && (universalService.activeRepo == 'main' || universalService.activeRepo == 'share' || universalService.activeRepo == 'invite') && impl?.fileForPreview) {
      <p id="fileName" class="previewFileName" title="{{impl.fileForPreview?.objectName}}">{{impl.fileForPreview?.objectName}} </p>
    }
    @if (universalService.isMobileDevice) {
      <div>
        <span class="NeueExit-Folder temporary_CloseIcon" (click)="decideAction('closePreview')"></span>
        @if (impl.fileForPreview) {
          <p class="previewFileName" id="fileName" title="{{impl.fileForPreview?.objectName}}">{{impl.fileForPreview?.objectName}} </p>
        }
      </div>
    }
    @if ((!universalService.isMobileDevice && (universalService.activeRepo == 'main' || universalService.activeRepo == 'share' || universalService.activeRepo == 'invite'))) {
      <div class="preview-options-tab-inline-main">
        <div class="left-icon-set">
          <div class="float-right pr-lg-3 top-menu-option-container">
            @for (item of universalService.topMenuOptions; track item) {
              <span>
                @if (!(item.iconName == 'NeueRemove' && universalService.hideDeleteForPublicPreviewShare)) {
                  <span
                    class="optionIcons {{item.iconName}} mr-4 pointer" title="{{item.title}}" data-toggle="modal" (click)="decideAction(item.onClick, $event)" [ngClass]="item.title == 'Share link' && this.universalService.isAllowPublicShare == false ? 'hideOption' : ''">
                  </span>
                }
              </span>
            }
          </div>
        </div>
        <!-- Dropdown menu -->
        @if (universalService.openMoreOptions) {
          <div class="dropdown-menu">
            @for (item of universalService.moreOptionsOnTopMenu; track item) {
              <span id="{{item.onClick}}" class="dropdown-item pointer" title="{{item.title}}" (click)="decideAction(item.onClick)" [ngClass]="item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                @if (item.iconName != '') {
                  <span class="optionIcons {{item.iconName}}"></span>
                }
                @if (item.imageUrl && item.iconName == '') {
                  <img class="img-fluid" src="{{item.imageUrl}}">
                  }{{item.menuItem}}<span class="{{item.moreOptionsIcon}} moreOptionsIcon"></span>
                </span>
              }
            </div>
          }
          @if (universalService.openMoreOptions && universalService.openMoreOptionsContextMenu) {
            <div class="dropdown-menu expandMoreOption">
              @for (item of universalService.contextMenuMoreOptions; track item) {
                <span class="dropdown-item pointer" title="{{item.title}}" (click)="decideAction(item.onClick)" [ngClass]="item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                  @if (item.iconName != '') {
                    <span class="optionIcons {{item.iconName}}" ></span>
                  }
                  @if (item.imageUrl  && item.iconName == '') {
                    <img class="img-fluid" src="{{item.imageUrl}}">
                  }
                  <span>{{item.menuItem}}</span>
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="modal-body" id="myObject" (click)="stopSlideShow()">
      @if (((!universalService.isPreviewOpenFromSearchDropdown && !impl.fileForPreview?.previewFromUpload && ((impl.objectsForPreview?.length>1 && !this.universalService.showAudioPreviewForFilter && this.universalService.currentTab != 'audio'))))) {
        <div class="previousIcon" (click)="fetchPrevious()" (keyup.arrowleft)="fetchPrevious()" data-toggle="tooltip"
          title="Previous"><span class="NeueExit-Folder"></span>
        </div>
      }
      <!-- This will work if isCacheEnabled = true -->
      @if (impl.isCacheEnabled == true && ((impl.fileForPreview && (impl.fileForPreview?.objectType == 'FE' ||impl.fileForPreview?.objectType == 'BE' || impl.fileForPreview?.objectType == 'DE')) || universalService.selectedFile?.objectType == 'BB' || universalService.selectedFile?.objectType == 'SE' )
        && impl.fileForPreview?.mimeType == 'image' && !impl.previewNotAvailable) {
        @for (imgFile of impl.cachedImgPreviewDataArray; track imgFile) {
          <div class="prvw-img-wrap cached-img" [ngStyle]="{'visibility':imgFile.isCurrentImage?'visible':'hidden'}">
            <img class="preview_img"
              src="{{this.universalService.currentTab!= 'PrivateFolder'?imgFile.imageUrl:imgFile.imageUrl+'&ppfToken='+this.ppfToken}}" alt="image-txt" title="{{imgFile.objectName}}" [ngStyle]="{'width':imgFile.imageWidth+'px','height':imgFile.imageHeight+'px','display':'block'}" [ngClass]="[impl.previewDirection == 'next' ? 'slideFromRightToLeft' : 'slideFromLeftToRight']">
          </div>
        }
      }
      <!-- End -->
      <!-- This will work if isCacheEnabled = false -->
      @if (impl.isCacheEnabled == false && ((impl.fileForPreview && (impl.fileForPreview?.objectType == 'FE' ||impl.fileForPreview?.objectType == 'BE' || impl.fileForPreview?.objectType == 'DE')) || universalService.selectedFile?.objectType == 'BB' || universalService.selectedFile?.objectType == 'SE' ) && impl.fileForPreview?.mimeType == 'image' && !impl.previewNotAvailable) {
        <img class="preview_img noncached-img"
          src="{{this.universalService.currentTab!= 'PrivateFolder'?impl.fileForPreview?.imageUrl:impl.fileForPreview?.imageUrl+'&ppfToken='+this.ppfToken}}" (error)="ImageDoesnotExist($event)" alt="" title="{{impl.fileForPreview?.objectName}}" [ngStyle]="{'top' : impl.fileForPreview?.top+'px','width':impl.fileForPreview?.imageWidth+'px','height':impl.fileForPreview?.imageHeight+'px'}" [ngClass]="[impl.previewDirection == 'next' ? 'slideFromRightToLeft' : 'slideFromLeftToRight']">
      }
      <!-- End -->
      @if(universalService.activeRepo == 'invite' && impl.fileForPreview?.actualMimeType == 'video'){
        <div class="invite-dummy-play-btn">
          <span class="NeuePlayFilledEllipse" (click)="redirectToSignin()"></span>
        </div>
      }
      
      <div id="pdf-view-container">
        <!-- <iframe id="pdfview"></iframe> -->
        <ng2-pdfjs-viewer  *ngIf="impl.pdfBlobUrl" [pdfSrc]="impl.pdfBlobUrl" viewerId="blobViewer" [showAll]="false"></ng2-pdfjs-viewer>
        <!--[page]="1"  [showToolbar]="false"   [fullScreen]="false" [print]="false" [download]="false" [find]="false" [openFile]="false"   [viewBookmark]="false" [showRotate]="false" -->
      </div>

      <div id="frameholder" class="hide docEditFrameCont">
        <iframe id="doceditIframe" name="doceditFrame" scrolling="auto" allowfullscreen="true" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"></iframe>
      </div>
      <div class="docEditCont">
        <form name='docditform' id='docditform' method='post' target="doceditFrame"></form>
      </div>
      @if (((!universalService.isPreviewOpenFromSearchDropdown && !impl.fileForPreview?.previewFromUpload && ((impl.objectsForPreview?.length>1 && !this.universalService.showAudioPreviewForFilter && this.universalService.currentTab != 'audio'))))) {
        <div class="nextIcon" (click)="fetchNext()" (keyup.arrowright)="fetchNext()">
          <span class="NeueEnter_Folder" data-toggle="tooltip" title="Next"></span>
        </div>
      }

      @if (impl.mediaFiles && impl.videoFiles && !impl.previewNotAvailable) {
        jhj
        <common-jio-media-player (previewError)="isErrorinPreviewing($event)" [previewDirection]="impl.previewDirection"/>
      }

      @if (impl.mediaFiles && impl.audioFiles && !impl.previewNotAvailable) {
        <lib-audioclappr (previewError)="isErrorinPreviewing($event)" [previewDirection]="impl.previewDirection"/>
      }


      @if (impl.previewNotAvailable) {
        <div class="container no-preview-cont">
          <div class="no-preview-wrapper">
            <div class="default-doc-holder" data-toggle="tooltip" title={{impl.fileForPreview?.objectName}}>
              @switch (impl.fileForPreview?.format){
                @case ('image') {
                  <span class="NeueImageFilled img-tile"></span>
                }
                @case ('text') {
                  <span class="NeueTXTFilled txt-tile"></span>
                }
                @case ('application') {
                  <span class="NeueOtherFiles other-tile"></span>
                }
                @case ('video') {
                  <span class="NeuePlayFilled video-tile"></span>
                }
                @case ('audio') {
                  <span class="NeueAudio audio-tile"></span>
                }
              }
              @if(impl.fileForPreview?.format == 'Document' || impl.fileForPreview?.format == 'SpreadSheet' || impl.fileForPreview?.format == 'Presentation' || impl.fileForPreview?.format == 'MSOfficeDocument'){
                <img draggable="false" class="img-fluid img-thumbnail" src="{{impl.fileForPreview?.MSOfficeImage}}" data-toggle="tooltip" alt="" />
              }
              <div class="docName">
                <h6>{{impl.fileForPreview?.objectShortName}}</h6>
                <span class="fileSize">{{impl.fileForPreview?.objectSize}}</span>
              </div>
            </div>
            <div class="noPreviewText">
              <p>No preview available for this file</p>
              @if (!universalService.iOSdevice) {
                <div class="download_btn">
                  <button class="Download ripple-fx" (click)="downloadItems()">Download</button>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>